<!-- Activacion de cuenta (/actPass?b=…, el enlace del correo de alta). Mismo diseño que /login
     (clases lg2-* del parcial ../../login-v2/_login-shell.scss). Logica igual que antes:
     activateUser(b) → listo / error → vuelve a /login. -->
<div class="lg2-page">

  <!-- ── Panel de marca ── -->
  <aside class="lg2-brand">
    <div class="lg2-brand-grid" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--a" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--b" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--c" aria-hidden="true"></div>

    <div class="lg2-mark">
      <img src="assets/icon.png" alt="" class="lg2-mark-cube">
      <span class="lg2-mark-word">CUBE</span>
      <span class="lg2-mark-tag">Customer portal</span>
    </div>
    <p class="lg2-mobile-tag">Your account, ready to go</p>

    <!-- ilustracion unica (datos de ejemplo): la cuenta activada -->
    <div class="lg2-slides">
      <section class="lg2-slide is-active">
        <div class="lg2-ill" aria-hidden="true">
          <div class="lg2-ill-halo"></div>
          <div class="lg2-ic lg2-ic--main">
            <div class="lg2-ic-hd"><i class="fas fa-user-check"></i> Account</div>
            <div class="ap-row"><span class="ap-avatar">AL</span><span class="ap-lines"><i></i><i></i></span></div>
            <div class="ap-status"><i class="fas fa-check-circle"></i> Active</div>
          </div>
          <div class="lg2-ic lg2-ic--chip lg2-ic--tr"><i class="fas fa-envelope"></i> Email verified</div>
          <div class="lg2-ic lg2-ic--chip lg2-ic--bl lg2-ic--ok"><i class="fas fa-shield-alt"></i> Secure access</div>
          <span class="lg2-bubble lg2-bubble--1"><i class="fas fa-key"></i></span>
          <span class="lg2-bubble lg2-bubble--2"><i class="fas fa-building"></i></span>
          <span class="lg2-bubble lg2-bubble--3"><i class="fas fa-clipboard-list"></i></span>
        </div>
        <h2 class="lg2-slide-title">Everything about your service, in one place</h2>
        <p class="lg2-slide-txt">Follow your work orders, see your sites and equipment, and request service whenever you need it.</p>
      </section>
    </div>
    <div></div>
  </aside>

  <!-- ── Estado de la activacion ── -->
  <main class="lg2-form-wrap">
    <div class="lg2-card ap-card">
      <ng-container *ngIf="status === 'activating'">
        <span class="lg2-key ap-key--wait" aria-hidden="true"><dx-load-indicator [visible]="true" height="24" width="24"></dx-load-indicator></span>
        <h2 class="lg2-title">Activating your account…</h2>
        <p class="lg2-subtitle">This only takes a moment.</p>
      </ng-container>

      <ng-container *ngIf="status === 'done'">
        <span class="lg2-key ap-key--ok" aria-hidden="true"><i class="fas fa-check"></i></span>
        <h2 class="lg2-title">Your account is active</h2>
        <p class="lg2-subtitle">Welcome to CUBE Edge. Sign in with your email and password to get started.</p>
        <button type="button" class="lg2-submit" (click)="goLogin()">
          <span>Go to sign in</span>
          <i class="fas fa-arrow-right lg2-submit-arrow"></i>
        </button>
      </ng-container>
    </div>
  </main>
</div>
